import { render, staticRenderFns } from "./SuportPagePDV.vue?vue&type=template&id=4704cefc&"
import script from "./SuportPagePDV.vue?vue&type=script&lang=js&"
export * from "./SuportPagePDV.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4704cefc')) {
      api.createRecord('4704cefc', component.options)
    } else {
      api.reload('4704cefc', component.options)
    }
    module.hot.accept("./SuportPagePDV.vue?vue&type=template&id=4704cefc&", function () {
      api.rerender('4704cefc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/faq/SuportPagePDV.vue"
export default component.exports